import type { RouterReducerState } from '@ngrx/router-store';
import { routerReducer } from '@ngrx/router-store';
import type { ActionReducerMap } from '@ngrx/store';
import type { FlagsmithFeatureFlagState } from './flagsmith-feature-flag.reducer';
import { flagsmithFeatureFlagReducer, flagsmithFeatureFlagStateKey } from './flagsmith-feature-flag.reducer';
import type { ProductsState } from './products.reducer';
import { productsReducer, productsStateKey } from './products.reducer';
import type { CustomRouterState } from './router.reducer';
import { routerReducerStateKey } from './router.reducer';
import type { SalesLookupState } from './sales-lookup.reducer';
import { salesLookupReducer, salesLookupStateKey } from './sales-lookup.reducer';
import type { SalesYearsState } from './sales-years.reducer';
import { salesYearsReducer, salesYearsStateKey } from './sales-years.reducer';
import type { SystemInfoState } from './system-info.reducer';
import { systemInfoReducer, systemInfoStateKey } from './system-info.reducer';
import type { UserState } from './user.reducer';
import { userReducer, userStateKey } from './user.reducer';

export interface State {
  [routerReducerStateKey]: RouterReducerState<CustomRouterState>;
  [flagsmithFeatureFlagStateKey]: FlagsmithFeatureFlagState;
  [salesYearsStateKey]: SalesYearsState;
  [userStateKey]: UserState;
  [systemInfoStateKey]: SystemInfoState;
  [productsStateKey]: ProductsState;
  [salesLookupStateKey]: SalesLookupState;
}

// map meta-level reducers that do not have their own module but
//  need to be part of state
export const reducers: ActionReducerMap<State> = {
  [routerReducerStateKey]: routerReducer,
  [flagsmithFeatureFlagStateKey]: flagsmithFeatureFlagReducer,
  [salesYearsStateKey]: salesYearsReducer,
  [userStateKey]: userReducer,
  [systemInfoStateKey]: systemInfoReducer,
  [productsStateKey]: productsReducer,
  [salesLookupStateKey]: salesLookupReducer,
};

export * from './flagsmith-feature-flag.reducer';
export * from './products.reducer';
export * from './router.reducer';
export * from './sales-lookup.reducer';
export * from './sales-years.reducer';
export * from './system-info.reducer';
export * from './user.reducer';
